/**
 * The bell notice that tells a candidate their named employer answered.
 *
 * The server records the employer's answer on the candidate's metadata, which the candidate cannot
 * write. The notice shows until the candidate opens it, which stores that answer's date in their own
 * private data as seen; a later answer has a later date, so it shows again.
 */

const ANSWERED_STATUSES = ['confirmed', 'denied'];

// { employerName, status, answeredAt } for an answer the candidate has not seen yet, else null.
export const employerAnswerNoticeOf = currentUser => {
  const profile = currentUser?.attributes?.profile;
  const answer = profile?.metadata?.currentEmployerConfirmation;
  if (!answer || !ANSWERED_STATUSES.includes(answer.status)) return null;
  const { employerName, status, answeredAt } = answer;
  if (typeof answeredAt !== 'string' || !answeredAt) return null;
  if (typeof employerName !== 'string' || !employerName) return null;
  if (profile?.privateData?.currentEmployerAnswerSeenAt === answeredAt) return null;
  return { employerName, status, answeredAt };
};

export const employerAnswerNoticeText = ({ employerName, status }) =>
  status === 'confirmed'
    ? `${employerName} confirmed it is your current employer`
    : `${employerName} did not confirm it is your current employer`;
